import { render, staticRenderFns } from "./UserInvites.vue?vue&type=template&id=53607086&"
import script from "./UserInvites.vue?vue&type=script&lang=js&"
export * from "./UserInvites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports